/*
 * Mixins and values meant for control components:
 * Buttons, Chip, Dropdown, Select, FormInput, etc
 *
 * TODO: Migrate things off of legacy sizes (sm, md, lg)
 * and delete the references here
 */

export var controlSizes = ['small', 'medium', 'large'];
export var controlSizesLegacy = ['sm', 'md', 'lg'];
export var getNextControlSize = function getNextControlSize(sizeName) {
  var controlSizesMap = {
    sm: 'small',
    md: 'medium',
    lg: 'large',
    small: 'small',
    medium: 'medium',
    large: 'large'
  };
  return controlSizesMap[sizeName];
};
export var getLegacyControlSize = function getLegacyControlSize(sizeName) {
  var controlSizesMap = {
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    small: 'sm',
    medium: 'md',
    large: 'lg'
  };
  return controlSizesMap[sizeName];
};
export var controlPaddingBlock = {
  small: '4px',
  medium: '8px',
  large: '12px',
  sm: '4px',
  md: '8px',
  lg: '12px'
};
export var controlIconSize = {
  small: 'small',
  medium: 'medium',
  large: 'medium'
};
export var controlGraphicSize = {
  small: 'smaller',
  medium: 'base',
  large: 'base'
};